import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { parse as parseQuery, stringify as querify } from 'qs';
import { omit } from 'lodash/fp';

import LoginModal from '../User/components/LoginModal/LoginModal';
import SignUpModal from '../User/components/SignUpModal/SignUpModal';
import DepositModal from '../Account/components/Deposit/DepositModal';
import ForgotPasswordModal from '../User/components/ForgotPasswordModal/ForgotPasswordModal';
import ResetPasswordModal from '../User/components/ResetPasswordModal/ResetPasswordModal';
import TAndCModal from './TAndCModal';
import UpdatePasswordModal from '../Account/components/Profile/UpdatePasswordModal';
import USDepositModal from '../Account/components/USDeposit/USDepositModal';
import appConfig from '../appConfig';
import WhatsNewModal from './WhatsNewModal/WhatsNewModal';
import AccountVerificationModal from './AccountVerificationModal/AccountVerificationModal';
import OnboardingDepositModal from '../Account/components/Deposit/OnboardingDepositModal';
import AvatarUploaderModal from './AvatarUploaderModal';
import GreenIdModal from '../Account/components/Profile/GreenIdModal';
import RGSModal from './RGSModal';

interface Props {
	smallScreen?: boolean;
	isSignedIn?: boolean;
}

const RouteModal: React.FC<Props> = ({ isSignedIn, smallScreen }) => {
	const mounted = React.useRef<boolean>();

	const history = useHistory();
	const location = useLocation();
	const showRG = appConfig.regions.isUS;

	React.useEffect(() => {
		if (!mounted.current) {
			mounted.current = true;
			return;
		}

		const { modal = '' } = parseQuery(location.search, { ignoreQueryPrefix: true }) || {};

		if (isSignedIn && ['reset-password', 'login', 'signup'].includes(modal.toString())) {
			handleClose();
		}
	});

	const handleClose = () => {
		const query = parseQuery(location.search, { ignoreQueryPrefix: true });
		const searchString = querify(omit('modal')(query), {
			addQueryPrefix: true,
		});

		history.push({
			...location,
			search: searchString,
		});
	};

	const { modal } = parseQuery(location.search, { ignoreQueryPrefix: true });

	switch (modal) {
		case 'login':
			return <LoginModal onClose={handleClose} showRG={showRG} />;
		case 'forgot-password':
			return <ForgotPasswordModal onClose={handleClose} showRG={showRG} />;
		case 'signup':
			return <SignUpModal onClose={handleClose} smallScreen={smallScreen} showRG={showRG} />;
		case 'update-password':
			return <UpdatePasswordModal onClose={handleClose} />;
		case 'reset-password':
			return <ResetPasswordModal onClose={handleClose} smallScreen={smallScreen} showRG={showRG} />;
		case 'deposit':
			if (appConfig.regions.language === 'enUS') {
				return <USDepositModal onClose={handleClose} showRG={showRG} />;
			}
			return <DepositModal onClose={handleClose} showRG={showRG} />;
		case 'verify':
			return <GreenIdModal onClose={handleClose} />;
		case 'terms-and-conditions':
			return <TAndCModal onClose={handleClose} />;
		case 'whatsnew':
			return <WhatsNewModal onClose={handleClose} />;
		case 'onboarding-verification':
			return <AccountVerificationModal />;
		case 'onboarding-deposit':
			return <OnboardingDepositModal onClose={handleClose} />;
		case 'avatar-upload':
			return <AvatarUploaderModal onClose={handleClose} />;
		case 'rgs':
			return <RGSModal onClose={handleClose} />;
		default:
	}
	return null;
};

export default RouteModal;

RouteModal.defaultProps = {
	smallScreen: false,
	isSignedIn: false,
};
